<template>
	<div>
		<q-carousel
			v-if="banners_desktop.length > 0 && $q.platform.is.desktop"
			:navigation="banners_desktop.length > 1"
			:arrows="banners_desktop.length > 1"
			animated
			:autoplay="6000"
			infinite
			swipeable
			keep-alive
			v-model="slide"
			transition-prev="slide-right"
			transition-next="slide-left"
			control-color="white"
			class="banner-height"
		>
			<q-carousel-slide
				:name="banner.id"
				class="column no-wrap flex-center"
				:class="banner.url ? 'cursor-pointer' : ''"
				v-for="banner in banners_desktop"
				:key="banner.id"
				:img-src="banner.image_desktop"
				:aria-label="
					banner.banner_image_alt_texts?.length ? banner.banner_image_alt_texts[0].alt_text : ''
				"
				role="img"
				@click="openLink(banner)"
			>
			</q-carousel-slide>
		</q-carousel>

		<div
			class="row q-col-gutter-x-md q-col-gutter-y-md q-pa-md"
			v-if="banners_mobile.length > 0 && $q.platform.is.mobile"
		>
			<div class="col-12">
				<q-carousel
					:navigation="banners_mobile.length > 1"
					:arrows="banners_mobile.length > 1"
					animated
					:autoplay="6000"
					infinite
					swipeable
					v-model="slide"
					transition-prev="slide-right"
					transition-next="slide-left"
					control-color="white"
					height="25vh"
				>
					<q-carousel-slide
						:name="banner.id"
						class="column no-wrap flex-center rounded-carousel"
						:class="banner.url ? 'cursor-pointer' : ''"
						v-for="banner in banners_mobile"
						:key="banner.id"
						:img-src="banner.image_mobile"
						@click="openLink(banner)"
						:aria-label="
							banner.banner_image_alt_texts?.length
								? banner.banner_image_alt_texts[banner.banner_image_alt_texts.length - 1].alt_text
								: ''
						"
						role="img"
					>
					</q-carousel-slide>
				</q-carousel>
			</div>
		</div>

		<q-carousel
			keep-alive
			v-model="slide_skeleton"
			transition-prev="slide-right"
			transition-next="slide-left"
			control-color="white"
			class="banner-height"
			v-if="banners_desktop.length === 0 && $q.platform.is.desktop && loading"
		>
			<q-carousel-slide
				:name="index + 1"
				class="column no-wrap flex-center rounded-carousel"
				v-for="(banner, index) in 4"
				:key="`bd-${index}`"
			>
				<q-skeleton width="100%" height="340px" />
			</q-carousel-slide>
		</q-carousel>

		<div
			class="row q-col-gutter-x-md q-col-gutter-y-md q-pa-md"
			v-if="banners_mobile.length === 0 && $q.platform.is.mobile && loading"
		>
			<div class="col-12">
				<q-carousel
					v-model="slide_skeleton"
					transition-prev="slide-right"
					transition-next="slide-left"
					control-color="white"
					height="25vh"
				>
					<q-carousel-slide
						:name="index + 1"
						class="column no-wrap flex-center rounded-carousel"
						v-for="(banner, index) in 4"
						:key="`bm-${index}`"
					>
						<q-skeleton width="100%" height="255px" />
					</q-carousel-slide>
				</q-carousel>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'BannerPortfolio',

	props: ['type_slug', 'banner'],

	data() {
		return {
			slide: null,
			banners_desktop: [],
			banners_mobile: [],
			slide_skeleton: 1,
			loading: true,
		}
	},

	computed: {
		...mapGetters({
			country: 'portfolio/country',
		}),

		getHeight() {
			if (this.$q.screen.lt.md) return '340px'
			else return 'return 255px'
		},
	},

	methods: {
		loadBanners() {
			if (this.type_slug !== 'about_team') {
				this.loading = true

				this.$axios
					.get(
						`/etraining_portfolio/banners/${this.country.value}/?banner_type_slug=${this.type_slug}`
					)
					.then((response) => {
						if (response.data.length > 0) {
							this.banners_desktop = response.data.filter((e) => e.image_desktop)
							this.banners_mobile = response.data.filter((e) => e.image_mobile)
							this.slide = response.data[0].id
						}
					})
					.catch((e) => {
						console.log(e)
					})
					.finally(() => {
						this.loading = false
					})
			} else {
				if (this.banner) {
					this.banners_desktop = this.banner
					this.banners_mobile = this.banner
					this.slide = this.banner[0].id
				}
			}
		},

		openLink(banner) {
			if (banner.url) {
				let url = new URL(banner.url)
				if (url.origin === process.env.SITE_URL) this.$router.push({ path: url.pathname })
				else window.open(banner.url)
			}
		},
	},

	mounted() {
		if (this.country) this.loadBanners()
	},

	watch: {
		country: {
			handler: function (newValue) {
				this.banners_desktop = []
				this.banners_mobile = []
				if (this.country) this.loadBanners()
			},
		},
	},
}
</script>

<style lang="scss" scoped>
@media (max-width: $breakpoint-sm-max) {
	.banner-height {
		height: 255px;
	}
}
@media (min-width: $breakpoint-md-min) {
	.banner-height {
		height: 340px;
	}
}
.rounded-carousel {
	border-radius: 20px;
}
</style>
